import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M8 12.333a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667ZM8.5 4a.5.5 0 1 0-1 0v5.333a.5.5 0 0 0 1 0V4Z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M2.932 2.932A7.146 7.146 0 0 1 8 .833c1.979 0 3.771.803 5.068 2.1A7.146 7.146 0 0 1 15.167 8a7.146 7.146 0 0 1-2.1 5.067A7.146 7.146 0 0 1 8 15.167a7.146 7.146 0 0 1-5.068-2.1A7.146 7.146 0 0 1 .833 8c0-1.98.803-3.772 2.1-5.068ZM8 1.833c-1.703 0-3.244.69-4.36 1.806A6.146 6.146 0 0 0 1.832 8c0 1.704.69 3.245 1.806 4.361A6.146 6.146 0 0 0 8 14.166c1.704 0 3.245-.69 4.361-1.806A6.146 6.146 0 0 0 14.167 8c0-1.703-.69-3.244-1.807-4.36A6.146 6.146 0 0 0 8 1.832Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }